import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Přihlášení se nezdařilo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative z-10 px-5">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <div className="border border-white/10 bg-[#0d0d0d] p-8 md:p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} className="text-[#ff3b30]" />
            <span className="font-head uppercase tracking-[0.25em] text-xs text-white/50">Administrace</span>
          </div>
          <h1 className="font-display text-4xl mb-8">PŘIHLÁŠENÍ</h1>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <input required type="email" data-testid="login-email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#111] border border-[#222] px-4 py-3.5 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff3b30]" />
            <input required type="password" data-testid="login-password" placeholder="Heslo" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#111] border border-[#222] px-4 py-3.5 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff3b30]" />
            {error && <p data-testid="login-error" className="text-[#ff3b30] text-sm">{error}</p>}
            <button disabled={loading} data-testid="login-submit" className="w-full font-head uppercase tracking-wider bg-[#ff3b30] text-white py-4 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-50">
              {loading ? "Přihlašování…" : "Přihlásit se"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
